import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import nl2br from "react-nl2br";
import ReactHtmlParser from "react-html-parser";
import SoundMessagePlayButton from "./soundMessagePlayButton";
import { showMoney, SmartImage } from "components/standart";
import TelegramButton from "components/standart/mediaButtons";

import { fileUrl } from "reducers/api";
import Col3Container from "./col3Container";

export const IntroSection = (props) => {
  const { env } = useSelector((state) => state.frontend);

  const { landings = {} } = env;
  const landingData = { ...landings[props.type] };
  const { title = "", content = "", fileId, isHtml } = { ...landingData?.intro };
  return title || content ? (
    <section className={`bg-white pb-${props.paddingBottom} pt-${props.paddingTop}`}>
      <div className="container py-1">
        <Col3Container>
          <div className="text-center">
            <div className="large-header pb-2">{nl2br(title)}</div>
            <div className="standart-header mb-4">
              {isHtml ? ReactHtmlParser(content) : nl2br(content)}
            </div>

            {fileId ? (
              <div className="mb-3">
                <SmartImage src={fileUrl(fileId)} width="100%" />
              </div>
            ) : null}

            {landingData.soundMessage?.fileId ? (
              <SoundMessagePlayButton sound={landingData.soundMessage} />
            ) : null}
            <div className="mb-2" />
          </div>
        </Col3Container>
      </div>
    </section>
  ) : null;
};

export const TariffsSection = (props) => {
  const { name } = props;
  const { env } = useSelector((state) => state.frontend);
  const { settings = {} } = env;
  const tariffs = settings[name];
  return tariffs && tariffs.title ? (
    <section className={`bg-white pb-${props.paddingBottom} pt-${props.paddingTop}`}>
      <div className={`mb-${props.marginTop}`} />
      <div className={`container`}>
        <Col3Container>
          <div className={`text-center ${props.containerClass}`}>
            <div className="large-header pb-2">{tariffs.title}</div>
            <div className="standart-header mb-2">{nl2br(tariffs.text)}</div>
            <div className="row">
              {_.map(tariffs.values, (data, index) => {
                return (
                  <div className="col-6 text-center px-3 px-lg-5" key={index}>
                    <div className="d-block w-100 py-2 -border -border-secondary -rounded text-center">
                      {/* <div className="large-header">{showMoney(data.value, "₽")} </div> */}
                      <div className="huge-header">{data.value}</div>
                      <div className="py-1"></div>
                      <div className="standart-header">{data.text}</div>
                      {data.url ? (
                        <div className="standart-header">
                          (
                          <a href={data.url} className="color-black" target="_blank">
                            пример
                          </a>
                          )
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={`mb-${props.marginBottom}`} />
        </Col3Container>
      </div>
    </section>
  ) : null;
};

export const IntroElement = (props) => {
  const { env } = useSelector((state) => state.frontend);

  const { landings = {} } = env;
  const landingData = { ...landings[props.type] };
  const { title = "", content = "", fileId, isHtml } = { ...landingData?.intro };
  return title || content ? (
    <div className={`text-center pb-${props.paddingBottom} pt-${props.paddingTop}`}>
      <div className="large-header pb-2">{nl2br(title)}</div>
      <div className="standart-header mb-4">
        {isHtml ? ReactHtmlParser(content) : nl2br(content)}
      </div>

      {fileId ? (
        <div className="mb-3">
          <SmartImage src={fileUrl(fileId)} width="100%" />
        </div>
      ) : null}

      {landingData.soundMessage?.fileId ? (
        <SoundMessagePlayButton sound={landingData.soundMessage} />
      ) : null}
      <div className="mb-2" />
    </div>
  ) : null;
};

export const BlockSection = (props) => {
  const { env } = useSelector((state) => state.frontend);
  const { landings = {} } = env;
  const landingData = { ...landings[props.type] };
  const { title = "", fileId, buttons, content = "", isHtml } = { ...landingData[props.blockName] };
  return title || content ? (
    <section
      className={`${props.bgColor || "bg-white"} pb-${props.paddingBottom || 0} pt-${
        props.paddingTop
      }`}
    >
      <div className={`mb-${props.marginTop}`} />
      <div className="container py-1">
        <Col3Container>
          <div className={`text-center ${props.containerClass}`}>
            <div className="large-header pb-2">{title}</div>
            <div className="standart-header content-html mb-4">
              {isHtml ? ReactHtmlParser(content) : nl2br(content)}
            </div>
            {fileId ? (
              <div className="mb-3">
                <SmartImage src={fileUrl(fileId)} width="100%" />
              </div>
            ) : null}
            {_.size(buttons) ? (
              <div className="my-2">
                {_.map(buttons, (button, index) => {
                  return (
                    <div className="m-2 d-inline-block">
                      <TelegramButton
                        url={button.url}
                        button={button.title}
                        className="py-3 standart-header"
                        fileId={button.fileId}
                      />
                    </div>
                  );
                })}
              </div>
            ) : null}
            {props.children}
          </div>
        </Col3Container>
      </div>
      <div className={`mb-${props.marginBottom}`} />
    </section>
  ) : null;
};

export const CustomBlockSection = (props) => {
  return (
    <section
      className={`${props.bgColor || "bg-white"} pb-${props.paddingBottom || 0} pt-${
        props.paddingTop
      }`}
    >
      <div className={`mb-${props.marginTop}`} />
      <div className="container py-1">
        <Col3Container>{props.children}</Col3Container>
      </div>
      <div className={`mb-${props.marginBottom}`} />
    </section>
  );
};
